export const AUTH = "auth";
